import { ReactNode } from "react";

import { Layout } from "antd";

export interface PageColumnsProps {
    children: ReactNode;
}

export function PageColumns({ children }: PageColumnsProps) {
    return <Layout hasSider>{children}</Layout>;
}
